import React from "react";
import TableComponent from "../../../../components/dashboard-components/table-component/table-component";
import * as Decorators from "../../../../styles/cell-decorators";
import { LoaderWidths } from "../../../../components/tables/simple-table/simple-table";

export default function AverageListedPriceTableComponent(props) {
  const { currency } = props;
  const title = "Average Retail Price";

  const columns = [
    {
      id: 1,
      label: "Account Name",
      accessor: "accountName",
      tooltip: "Customer Account",
      cellDecorator: Decorators.basicDecorator,
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 2,
      label: "Department",
      accessor: "department",
      tooltip: "Department Name. L1 or L2 in retailers' taxonomy.",
      cellDecorator: Decorators.basicDecorator,
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 3,
      label: "Category",
      accessor: "productType",
      tooltip: "Name of product category",
      cellDecorator: Decorators.basicDecorator,
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 4,
      label: "Category Avg. Retail Price",
      accessor: "categoryAvgRetailPrice",
      tooltip:
        "The average retail price for all items in a given category. Includes non-selling items.",
      cellDecorator: Decorators.priceDecoratorWrapper(currency, "category_avg"),
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 5,
      label: "Category Avg. Retail Price Diff",
      accessor: "categoryAvgRetailPriceDiff",
      tooltip:
        "Percent change in category average retail price between the current time period and the previous period listed above",
      cellDecorator: Decorators.percentChangeDecorator,
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 6,
      label: "Account Avg. Retail Price",
      accessor: "accountAvgRetailPrice",
      tooltip:
        "The average retail price for all items in a given category for your account. Includes non-selling items.",
      cellDecorator: Decorators.priceDecoratorWrapper(currency, "account_avg"),
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 7,
      label: "Account Avg. Retail Price Diff",
      accessor: "accountAvgRetailPriceDiff",
      tooltip:
        "Percent change in your company's average retail price between the current time period and the previous period listed above.",
      cellDecorator: Decorators.percentChangeDecorator,
      loaderWidth: LoaderWidths.Big,
    },
    {
      id: 8,
      label: "Account Avg. Retail Price Diff vs Category",
      accessor: "accountAvgRetailPriceDiffVsCategory",
      tooltip:
        "Percent difference between your company's prices and the overall category's prices (negative = your company's prices are lower, positive = higher)",
      cellDecorator: Decorators.percentChangeDecorator,
      loaderWidth: LoaderWidths.Big,
    },
  ];

  return (
    <TableComponent
      {...props}
      title={title}
      isEnabled={true}
      columns={columns}
      sortingColumn={columns[0]}
      hideColumnsDropdown={true}
      csvName={title}
    />
  );
}
